import { FileSignature, CheckCircle2 } from 'lucide-react';
import { useT } from '@/i18n';

/**
 * F5-T8 · Supervisor — «Preautorizaciones» (contrato Supervisor, sección 02).
 *
 * PLACEHOLDER DE CONSTRUCCIÓN, a propósito: el contrato dibuja la bandeja
 * completa (lista por antigüedad con cápsulas ámbar >3 días, panel de firma
 * con modos Aprobar/Denegar como segmented — nunca dos botones gemelos —,
 * motivo obligatorio para denegar con diagnóstico del deshabilitado, candado
 * «Nadie firma su propio pedido», estados «Ya la firmó X» y bandeja vacía en
 * salvia), pero TODO eso necesita server: no existe hoy ni el endpoint de
 * pendientes de firma ni el de firmar/denegar, ni el contador vivo del badge.
 * Esta pantalla le da a la entrada un destino honesto en el árbol del
 * supervisor mientras la API llega; lo único que ya es doctrina firmada y se
 * puede decir es la semántica de la aprobación (nunca gateó referir).
 */
export function PreauthorizationsPage(): JSX.Element {
  const t = useT();
  return (
    <div className="max-w-[760px] animate-fade-up-slow motion-reduce:animate-none">
      <p className="font-head text-[10.5px] font-bold tracking-[.14em] uppercase text-nav-teal mb-3">
        {t('f5t8.sup.preauthKicker')}
      </p>
      <div className="bg-white border-[1.5px] border-nav-teal rounded-[12px] py-6 px-[26px]" data-t8="preauth-placeholder">
        <div className="flex items-start gap-4">
          <span className="w-10 h-10 flex-none rounded-full bg-nav-tealTint text-nav-tealDark inline-flex items-center justify-center">
            <FileSignature className="w-5 h-5" aria-hidden />
          </span>
          <div className="min-w-0">
            <h3 className="font-head text-[17px] font-bold text-nav-navy">{t('f5t8.sup.preauth')}</h3>
            <p className="font-body text-[13.5px] text-nav-slate leading-relaxed mt-1.5">
              {t('f5t8.sup.preauthPending')}
            </p>
          </div>
        </div>
        <div className="flex items-start gap-2.5 mt-5 rounded-[12px] border-[1.5px] border-nav-sage bg-[#eef4ee] py-[15px] px-[17px] text-nav-sageText">
          <CheckCircle2 className="h-[17px] w-[17px] flex-none mt-px" aria-hidden />
          <p className="font-body text-[13.5px] leading-relaxed">{t('f5t8.sup.preauthSemantics')}</p>
        </div>
      </div>
    </div>
  );
}
